var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.comments.length > 0
    ? _c(
        "div",
        _vm._l(_vm.comments, function (comment, index) {
          return _c("completeness-check-modal-comment", {
            key: index,
            attrs: { "comment-data": comment },
          })
        }),
        1
      )
    : _c("pui-loader-error", {
        attrs: {
          title: _vm.$t("completenessCheckPage.noData"),
          message: _vm.$t("completenessCheckPage.modal.noComments"),
          icon: "error-empty-data",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }